import React from 'react';
const FuelIcon = (props) => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="40" cy="40" r="40" fill="#F9FAFB" />
    <rect
      width="6.07802"
      height="5.09742"
      transform="matrix(0.700226 0.713922 -0.713944 0.700203 25.2734 23.7578)"
      fill="#667085"
    />
    <rect
      width="5.1097"
      height="10.6076"
      rx="1.21561"
      transform="matrix(0.700226 0.713922 -0.713944 0.700203 24.0508 18.5391)"
      fill="#344054"
    />
    <path
      d="M21.7441 58.8533V33.5179C21.7441 32.4839 22.1395 31.4889 22.8492 30.7369L31.1207 21.9719C33.8 19.1326 37.5312 17.5234 41.4351 17.5234H52.3374C54.5753 17.5234 56.3894 19.3376 56.3894 21.5755V58.8533C56.3894 61.0912 54.5753 62.9053 52.3374 62.9053H25.7962C23.5583 62.9053 21.7441 61.0912 21.7441 58.8533Z"
      fill="#D9D6FE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.168 62.9053H52.3373C54.5752 62.9053 56.3893 61.0912 56.3893 58.8533V21.5755C56.3893 19.3376 54.5752 17.5234 52.3373 17.5234H41.435C40.6705 17.5234 39.9126 17.5851 39.168 17.7057V62.9053Z"
      fill="#9B8AFC"
    />
    <path
      d="M50.7165 31.9059V24.4099C50.7165 23.5147 49.9909 22.7891 49.0957 22.7891H41.7597C39.5837 22.7891 37.4991 23.6642 35.9751 25.2174L29.8503 31.4598C29.0957 32.2288 29.6406 33.5267 30.718 33.5267H49.0957C49.9909 33.5267 50.7165 32.8011 50.7165 31.9059Z"
      fill="#F9FAFB"
    />
    <path
      d="M28.2266 37.1719H50.1078M28.2266 37.1719V56.2161M28.2266 37.1719L50.1078 56.2161M50.1078 37.1719V56.2161M50.1078 37.1719L28.2266 56.2161M50.1078 56.2161H28.2266"
      stroke="#9B8AFC"
      strokeWidth="2.43121"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.168 57.4363H50.1086C50.78 57.4363 51.3242 56.8921 51.3242 56.2207V37.1765C51.3242 36.5052 50.78 35.9609 50.1086 35.9609H39.168V38.3921H46.8603L39.168 45.0871V48.3102L46.8603 55.0051H39.168V57.4363ZM41.0196 46.6986L48.893 39.8461V53.5512L41.0196 46.6986Z"
      fill="#7A5AF8"
    />
    <rect
      width="59.7981"
      height="2.5823"
      rx="1.29115"
      transform="matrix(0.753297 -0.65768 0.657704 0.753276 18 63.3281)"
      fill="#F04438"
    />
  </svg>
);

export default FuelIcon;
